module.exports = __webpack_public_path__ + "static/img/presysv75.ca2ab98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/presysv75.png
// module id = 7PHF
// module chunks = 1